import { AppService } from 'app/services/app.service';
import { AppFilter } from 'app/models/app-filter.model';

export abstract class AbGestaoPreCadastros extends AppService {
  abstract getPreCadastros(filter: AppFilter);
  abstract getExistsAguardando();
}
